import {
    request,
} from '../request.js'

// 添加
export function selectUserDocList(data) {
    return request({
        url: '/web/back/sys/navigationDoc/selectUserDocList',
        method: 'get',
        params: data
    })
}

